import React, { useState, useEffect, useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import revealBg from "../assets/img/relevent.svg";

if (typeof window !== "undefined") {
  gsap.registerPlugin(ScrollTrigger);
}

const FRAMES = [
  <path key="f0" transform="translate(-300.896, -66.448)" d="M286.447 63.2759C290.704 63.3593 293.349 61.6064 294.833 62.3576C295.966 62.9317 298.212 64.6994 300.979 65.5945C301.498 65.3577 302.053 65.1807 302.52 65.1238C303.771 64.9712 305.127 65.1335 305.481 65.7787C305.513 65.8382 305.53 65.9104 305.533 65.9926C308.569 65.455 310.811 63.4625 311.539 63.7768C312.41 64.1524 313.602 65.6599 316.022 67.6583C318.499 69.7034 321.731 70.1208 322.054 70.6217C322.376 71.1227 319.151 71.2896 316.022 70.1208C312.894 68.9521 311.668 67.5332 310.959 67.2827C310.353 67.0688 306.877 68.7408 303.465 68.8702C303.239 69.0346 303.005 69.1793 302.768 69.2945C301.636 69.8452 298.736 70.1466 298.11 70.1491C297.437 70.1517 297.076 70.1006 296.887 70.3265C296.577 70.6974 296.312 71.0038 296.091 71.0038C295.894 71.0038 295.826 70.6168 295.914 70.3588C296.002 70.1008 295.575 69.8427 295.722 69.617C295.87 69.3912 296.489 69.3589 296.784 69.1654C296.956 69.0522 297.662 68.3994 298.337 67.7481C296.14 66.7481 294.543 65.3884 294.059 64.9045C293.349 64.1955 290.317 65.6132 286.253 65.5299C282.19 65.4463 279.416 62.3578 279.738 62.1701C280.061 61.9825 282.19 63.1925 286.447 63.2759Z" fill="currentColor" />,
  <path key="f1" transform="translate(-452.576, -42.980)" d="M439.942 41.6338C442.73 40.3268 447.087 39.4555 447.61 39.4555C448.133 39.4555 449.352 40.7626 450.834 41.3725C452.315 41.9825 454.929 41.3289 455.278 40.8061C455.626 40.2834 457.892 40.8497 461.339 43.028C464.785 45.2063 470.265 50.3474 470.788 50.8702C471.31 51.393 471.13 47.9319 468.789 45.2063C465.647 41.5467 462.074 38.6712 459.024 37.277C455.975 35.8828 455.169 36.1734 454.668 35.7957C454.094 35.3633 453.186 34.5661 451.313 34.5758C450.12 34.582 448.655 35.0986 448.133 35.5342C447.61 35.9698 443.209 36.7541 439.68 38.976C436.772 40.8073 434.017 43.5505 433.929 44.2476C433.842 44.945 437.153 42.9409 439.942 41.6338Z" fill="currentColor" />,
  <path key="f2" transform="translate(-116.963, -10.910)" d="M134.434 6.26495C137.483 5.04506 137.222 0.86259 137.919 0.426961C138.616 -0.00866839 139.662 6.09079 136.176 8.44342C132.691 10.7962 129.118 9.9248 124.849 13.1487C123.607 14.0867 122.919 14.9868 122.435 15.7524C123.827 16.8508 125.843 18.5239 125.372 18.9918C124.762 19.597 122.025 19.0174 120.924 19.8183C119.938 20.5358 117.965 21.8279 117.094 21.1309C116.47 20.6318 117.186 18.8102 117.387 17.464C112.158 15.8934 109.036 18.1282 104.546 19.5098C100.015 20.9038 94.2643 17.1572 94.6128 16.5472C94.9614 15.9373 97.8368 16.7215 101.496 16.5472C105.156 16.3729 107.857 12.7134 111.604 12.4519C115.351 12.1904 117.738 15.5219 118.575 14.8045C119.185 14.2817 119.62 11.0577 122.757 9.31502C125.894 7.57201 131.384 7.48485 134.434 6.26495Z" fill="currentColor" />,
  <path key="f3" transform="translate(-21.631, -63.566)" d="M35.4173 63.3834C36.3643 63.7366 40.6266 67.7959 41.9946 68.3973C43.3627 68.9987 42.1525 66.8939 40.9423 64.2628C39.7321 61.6318 37.3642 57.7381 35.8383 58.3694C34.5274 58.9118 27.6634 62.7542 24.4368 63.6271C24.0171 62.7585 23.5933 62.158 23.3149 62.158C23.0845 62.158 22.7153 62.7136 22.3198 63.5015C19.5404 62.2705 13.409 57.7136 10.739 58.3694C9.59065 58.6515 6.52957 61.3161 4.0564 63.1577C1.58323 64.9994 -0.100579 65.7888 0.0046695 66.3149C0.109918 66.8411 3.63541 66.5148 5.95054 65.6781C8.26584 64.8416 12.1069 63.3155 13.5802 63.2104C14.8618 63.1188 19.7257 65.6546 20.9705 66.8011C20.6781 67.6708 20.4934 68.3855 20.526 68.63C20.6312 69.4192 24.3146 69.1561 25.2616 69.1561C25.8966 69.1561 25.94 68.446 25.7254 67.4234C26.3406 66.8196 27.6226 66.4111 29.2607 65.678C31.3657 64.7365 34.4702 63.0301 35.4173 63.3834Z" fill="currentColor" />,
  <path key="f4" transform="translate(-552.026, -10.793)" d="M559.004 0.892948C558.636 0.525237 556.491 0.15753 554.897 0.0961905C553.303 0.0348504 550.803 -0.0855273 548.461 0.0961905C546.678 0.234658 543.103 2.26759 542.184 2.95992C541.264 3.65226 541.003 5.45662 541.407 5.83732C541.711 6.1233 543.067 5.61252 544.722 5.12229C545.289 4.95439 545.9 4.80786 546.629 4.67087C546.358 5.20863 546.057 5.74951 545.642 6.16426C544.538 7.26756 541.842 11.3129 541.719 12.3548C541.596 13.3968 542.883 16.1549 543.68 17.5034C544.477 18.8519 546.071 21.6713 546.438 20.9359C546.806 20.2003 547.235 17.2584 546.99 15.7872C546.745 14.3162 546.009 12.171 546.438 11.5581C546.867 10.9452 548.093 9.1676 548.584 7.88045C549.074 6.59329 549.626 4.57072 550.239 4.57072C550.851 4.57072 554.652 5.36748 555.51 6.04172C556.368 6.71597 557.729 8.73856 559.04 9.59666C560.352 10.4548 562.313 11.4354 562.681 11.4354C563.049 11.4354 561.761 8.9224 560.842 7.57391C559.923 6.22542 557.908 4.38671 556.552 3.89632C556.057 3.7174 555.524 3.57958 555.001 3.4615C557.816 2.66688 559.299 1.18814 559.004 0.892948Z" fill="currentColor" />
];

function FlappingBird({ className, initialFrame = 0 }) {
  const [frame, setFrame] = useState(initialFrame);

  useEffect(() => {
    const interval = setInterval(() => {
      setFrame((f) => (f + 1) % 5);
    }, 140);
    return () => clearInterval(interval);
  }, []);

  return (
    <svg viewBox="-30 -15 60 30" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      {FRAMES[frame]}
    </svg>
  );
}

export const RevealSection = () => {
  const containerRef = useRef(null);
  const revealContentRef = useRef(null);

  useGSAP(() => {
    if (revealContentRef.current) {
      // Animate the content from a shifted down, blurred, and faded out state
      // creating a gorgeous sunrise rise-up effect as the page is scrolled to the bottom
      gsap.from(revealContentRef.current, {
        scrollTrigger: {
          trigger: ".footer-reveal-wrapper",
          start: "top bottom",
          end: "top+=300 bottom",
          scrub: 1.2,
        },
        y: 80,
        opacity: 0,
        filter: "blur(16px)",
        ease: "power2.out",
      });
    }
  }, { scope: containerRef });

  return (
    <section
      ref={containerRef}
      className="reveal-sticky-section"
      style={{
        backgroundImage: `url(${revealBg})`
      }}
    >
      <div ref={revealContentRef} className="reveal-content-container">
        {/* Flapping Birds (matching 100% of EduOneReveal) */}
        <div className="reveal-birds-container">
          <div className="animate-birds-far">
            <FlappingBird className="bird bird-1" initialFrame={0} />
            <FlappingBird className="bird bird-2" initialFrame={2} />
            <FlappingBird className="bird bird-3" initialFrame={4} />
          </div>
          <div className="animate-birds-near">
            <FlappingBird className="bird bird-4" initialFrame={1} />
            <FlappingBird className="bird bird-5" initialFrame={3} />
            <FlappingBird className="bird bird-6" initialFrame={0} />
          </div>
        </div>

        {/* Reveal branding text */}
        <div className="reveal-brand-text">
          <h2>USHAN MIHIRANGA</h2>
          <p>Software Engineer - 2026</p>
        </div>
      </div>
    </section>
  );
};

export default RevealSection;
